import {
  ProductForm_default
} from "./chunk--chunk-ZOQNBXBM.vbt.js";
import {
  handleGWP
} from "./chunk--chunk-FJ3DOTW4.vbt.js";
import {
  RechargeWidget_default
} from "./chunk--chunk-ZCOEP63T.vbt.js";
import "./chunk--chunk-KZZEYG53.vbt.js";
import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/AjaxCart.js
var AjaxCart = class _AjaxCart {
  static MIN_AFTERPAY_CART_TOTAL = 3500;
  static MAX_AFTERPAY_CART_TOTAL = 1e5;
  constructor(el) {
    this.el = el;
    this.type = window.location.href.includes("/cart") ? "cart-page" : "ajaxcart";
    const max = el.getAttribute("data-max");
    if (max) {
      this.max = parseInt(max);
    }
    this.emptyCartContent = el.querySelectorAll("[data-empty-cart-content]");
    this.cartWithItemsContent = el.querySelectorAll(
      "[data-cart-with-items-content]"
    );
    this.itemCount = document.querySelectorAll("[data-item-count]");
    const requestButtons = el.querySelectorAll(
      "[data-ajax-cart-request-button]"
    );
    requestButtons.forEach((button) => {
      button.addEventListener("click", (e) => this.buttonListener(e));
    });
    const requestInputs = el.querySelectorAll(
      "[data-ajax-cart-request-input]"
    );
    if (requestInputs.length > 0) {
      requestInputs.forEach((requestInput) => {
        requestInput.addEventListener("change", (e) => this.buttonListener(e, true));
      });
    }
    this.checkForAfterPayTotalPrice();
    this.checkForRechargeWidgets();
    document.addEventListener("ajaxcart refresh", async (e) => {
      const {
        detail: { subtotal, hasMin, itemCount }
      } = e;
      this.toggleContent(subtotal, itemCount, hasMin);
      this.debouncedCheckForAfterPayTotalPrice();
      const requestButtons2 = document.querySelectorAll(
        "[data-ajax-cart-request-button]"
      );
      requestButtons2.forEach((button) => {
        button.addEventListener("click", (e2) => this.buttonListener(e2));
      });
      this.checkForRechargeWidgets();
      if (document.querySelector("[data-redeem-rewards]")) {
        yotpoWidgetsContainer.initWidgets();
      }
      document.querySelector("#cart-drawer-toggle").checked = true;
    });
  }
  debouncedCheckForAfterPayTotalPrice() {
    if (this.afterpayCheckTimeout) {
      clearTimeout(this.afterpayCheckTimeout);
    }
    this.afterpayCheckTimeout = setTimeout(() => {
      this.checkForAfterPayTotalPrice();
    }, 1e3);
  }
  checkForAfterPayTotalPrice() {
    const rechargeWidgets = document.querySelectorAll(
      "[data-ajax-cart] [data-recharge-widget]"
    );
    const showAfterpay = window.afterpay_cart_total_price >= _AjaxCart.MIN_AFTERPAY_CART_TOTAL && window.afterpay_cart_total_price <= _AjaxCart.MAX_AFTERPAY_CART_TOTAL && rechargeWidgets.length === 0;
    const afterpayParentEls = document.querySelectorAll("div.afterpay-parent");
    if (afterpayParentEls.length > 0) {
      const classNameHideAfterpay = "hide-afterpay";
      afterpayParentEls.forEach((parent) => {
        if (showAfterpay) {
          parent.classList.remove(classNameHideAfterpay);
        } else {
          parent.classList.add(classNameHideAfterpay);
        }
      });
    }
  }
  checkForRechargeWidgets() {
    const rechargeWidgets = document.querySelectorAll(
      "[data-ajax-cart] [data-recharge-widget]"
    );
    if (rechargeWidgets.length > 0) {
      rechargeWidgets.forEach((rechargeWidget) => {
        new RechargeWidget_default(rechargeWidget, "data-recharge-widget").init();
      });
    }
  }
  initDrawerCloseListener() {
    document.addEventListener("cart drawer close", this.closeAllDropdowns);
  }
  closeAllDropdowns(selectToOpen) {
    document.querySelectorAll("[data-recharge-block] [data-recharge-select]").forEach((select) => {
      select.parentNode.querySelector(
        "[data-recharge-option-container]"
      ).style.display = "none";
    });
    if (selectToOpen) {
      selectToOpen.style.display = "block";
    }
  }
  async toggleContent(subtotal, itemCount, hasMin) {
    const freeSamples = document.querySelector("[data-free-samples]");
    if (freeSamples) {
      ((...args) => args.map((a) => freeSamples.classList.toggle(a, hasMin === "false")))(
        "opacity-0",
        "h-0",
        "pointer-events-none"
      );
      fetch("/cart").then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      }).then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const freeSamplesElement = tempDiv.querySelector("[data-free-samples]");
        const ajaxCartElement = document.querySelector("[data-ajax-cart] [data-free-samples]");
        if (ajaxCartElement && freeSamplesElement) {
          const freeItems = freeSamplesElement.querySelectorAll(".splide__list li");
          const cartItems = ajaxCartElement.querySelectorAll(".splide__list li");
          for (const cartItem of cartItems) {
            const freeItem = Array.from(freeItems).find((el) => el.querySelector("h3").innerHTML == cartItem.querySelector("h3").innerHTML);
            let cartEl, freeEl;
            if (cartItem.querySelector("[data-ajax-cart-request-button]")) {
              cartEl = "[data-ajax-cart-request-button]";
            } else if (cartItem.querySelector("[data-product-form]")) {
              cartEl = "[data-product-form]";
            } else {
              cartEl = "label";
            }
            if (freeItem.querySelector("[data-ajax-cart-request-button]")) {
              freeEl = "[data-ajax-cart-request-button]";
            } else if (freeItem.querySelector("[data-product-form]")) {
              freeEl = "[data-product-form]";
            } else if (freeItem.querySelector("label")) {
              freeEl = "label";
            }
            cartItem.querySelector(cartEl).replaceWith(freeItem.querySelector(freeEl));
            if (cartItem.querySelector("form")) {
              new ProductForm_default(cartItem.querySelector("form")).init();
            } else if (cartItem.querySelector("[data-ajax-cart-request-button]")) {
              cartItem.querySelector("[data-ajax-cart-request-button]").addEventListener("click", (e) => this.buttonListener(e));
            }
          }
        }
      }).catch((error) => {
        document.querySelectorAll(".free-sample-add-cta").forEach((el) => {
          el.disabled = false;
          el.style.cursor = "pointer";
        });
        console.error("Error fetching /cart page:", error);
      });
    }
    if (itemCount > 0) {
      this.emptyCartContent.forEach(
        (content) => content.style.display = "none"
      );
      this.cartWithItemsContent.forEach(
        (content) => content.style.display = "block"
      );
      this.itemCount.forEach((count) => {
        count.classList.remove("hidden");
        count.parentNode.classList.remove("hidden");
        count.textContent = itemCount;
      });
    } else {
      this.emptyCartContent.forEach(
        (content) => content.style.display = "block"
      );
      this.cartWithItemsContent.forEach(
        (content) => content.style.display = "none"
      );
      this.itemCount.forEach((count) => {
        count.classList.add("hidden");
        count.parentNode.classList.add("hidden");
      });
    }
    const subtotalEls = document.querySelectorAll("[data-subtotal]");
    subtotalEls.forEach((subtotalEl) => {
      subtotalEl.textContent = subtotal;
    });
    const atome = document.querySelector("#atome-payment");
    if (atome) {
      atome.innerHTML = "RM" + (parseFloat(subtotal.replace(/[RM,]/g, "")) / 3).toFixed(2);
    }
    if (hasMin === "false" && freeSamples) {
      await fetch("/cart/clear");
      ((...args) => args.map((a) => freeSamples.classList.add(a)))(
        "opacity-0",
        "h-0",
        "pointer-events-none"
      );
    }
  }
  async buttonListener(e, isInput) {
    e.preventDefault();
    e.stopPropagation();
    let reqURL;
    if (isInput) {
      reqURL = e.target.getAttribute("data-ajax-cart-request-input");
    } else {
      const anchor = e.target.tagName.toLowerCase() === "a" ? e.target : e.target.closest("a");
      if (anchor.hasAttribute("data-swell-item")) {
        document.dispatchEvent(
          new CustomEvent("swell item removed", {
            detail: {
              id: anchor.getAttribute("data-swell-item")
            }
          })
        );
      }
      reqURL = anchor.href;
    }
    const res = await fetch(reqURL);
    if (res.status === 200) {
      document.querySelectorAll("[data-rc-widget-checkbox]").forEach((el) => el.checked = false);
      handleGWP(this.type);
      this.debouncedCheckForAfterPayTotalPrice();
    }
  }
  triggerRefresh(div) {
    const subtotal = div.querySelector("#subtotal").value;
    const itemCount = div.querySelector("#item_count").value;
    const hasMin = div.querySelector("#has_min").value;
    const productHandles = div.querySelector("#product_handles").value;
    const gwp = div.querySelector("#gwp").value;
    document.dispatchEvent(
      new CustomEvent("ajaxcart refresh", {
        detail: {
          subtotal,
          itemCount,
          hasMin,
          productHandles,
          gwp
        }
      })
    );
    if (window.location.href.includes("/cart")) {
      window.scrollTo(0, 0);
      window.location.reload();
    }
  }
};
var AjaxCart_default = AjaxCart;
export {
  AjaxCart_default as default
};
